import React, { useState } from 'react';
import { ZodFormBuilder } from 'react-scale/corp/views/CorpProjectGroupManager/views/Linter/GenericLinterView/ZodFormBuilder';
import { Checkbox, SelectMenu, Tag, Typography } from '@scale/scaleui';
import { ToolCall, ToolCallStrategy } from './ToolCallStrategies/BaseToolStrategy';
import JSONInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/JSONInputBuilder';

interface ToolCallEditorProps {
  currentToolCall: ToolCall;
  strategy: ToolCallStrategy;
  onChange: (value: ToolCall) => void;
  readOnly: boolean;
}

const ToolCallEditor: React.FC<ToolCallEditorProps> = ({
  currentToolCall,
  strategy,
  onChange,
  readOnly,
}) => {
  const [jsonMode, setJsonMode] = useState(false);

  const functionName = currentToolCall.functionName;
  const zodSchema = strategy.getToolSchema(functionName);

  const currentParameters = currentToolCall.functionParameters;

  return (
    <div className="flex flex-col gap-2 w-full">
      <Typography.Subtitle3 className="flex flex-col items-start">
        <Tag className="mb-2 mt-2" size="lg" variant="primary">
          Tool
        </Tag>
      </Typography.Subtitle3>
      <SelectMenu
        disabled={readOnly}
        options={
          strategy.getToolIds().map((option: any) => ({
            id: option,
            name: option,
          })) || []
        }
        selectedOptionId={functionName}
        setSelected={(newValue: any) =>
          onChange({
            ...strategy.createBlankToolCall(),
            functionName: newValue,
          })
        }
        className="w-full mb-2"
      />
      <Typography.Subtitle3 className="flex flex-col items-start">
        <Tag className="mb-2" size="lg" variant="primary">
          Parameters
        </Tag>
      </Typography.Subtitle3>
      {
        <Checkbox
          checked={jsonMode}
          onChange={() => setJsonMode(!jsonMode)}
          label={'Edit as raw JSON'}
          disabled={readOnly}
        />
      }

      {jsonMode ? (
        <JSONInputBuilder
          name={'Parameters for tool call'}
          existingValue={currentParameters}
          updateProperty={(newValue: any) => {
            onChange({
              ...currentToolCall,
              functionParameters: newValue,
            });
          }}
        />
      ) : (
        <>
          {Object.keys(zodSchema._def.shape()).map(key => {
            const subSchema = zodSchema._def.shape()[key];

            return (
              <div className="flex flex-col gap-2" key={key}>
                <ZodFormBuilder
                  key={key}
                  label={key}
                  schema={subSchema}
                  // @ts-ignore
                  value={currentParameters?.[key]}
                  onChange={(newValue: any) => {
                    const newFullJson = {
                      ...currentParameters,
                      [key]: newValue,
                    };
                    // delete any keys that are not in the schema
                    Object.keys(newFullJson).forEach(k => {
                      if (!Object.keys(zodSchema._def.shape()).includes(k)) {
                        delete newFullJson[k];
                      }
                    });
                    onChange({
                      ...currentToolCall,
                      functionParameters: newFullJson,
                    });
                  }}
                  startOpen={true}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default ToolCallEditor;
